var _rect, _path, _path2, _g, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgLifeInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 106,
    viewBox: "0 0 112 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 106,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_832",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 106,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 53.5C111.375 82.4949 87.8699 106 58.875 106C29.8801 106 6.375 82.4949 6.375 53.5C6.375 24.5051 29.8801 1 58.875 1C87.8699 1 111.375 24.5051 111.375 53.5Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5241 24.5444C67.5251 24.5444 62.9674 26.6624 59.5205 30.1426C58.5614 31.1113 57.0205 31.1113 56.0613 30.1426C52.614 26.6619 48.0563 24.5444 43.0577 24.5444C32.302 24.5444 23.5811 34.3468 23.5811 46.4404C23.5811 57.0089 32.7479 74.9632 53.05 85.9561C54.2841 86.6241 55.5599 87.2666 56.8768 87.8799C57.457 88.1503 58.1249 88.1503 58.705 87.8799C60.0219 87.2666 61.2972 86.6241 62.5314 85.9561C82.8315 74.9632 91.9983 57.0089 91.9983 46.4404C91.9983 34.3468 83.2799 24.5444 72.5241 24.5444Z",
    fill: "#E62645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0001 46.4398C92.0001 57.0084 82.8318 74.9622 62.5302 85.955C61.2956 86.622 60.0232 87.2671 58.7029 87.8778C58.1232 88.1492 57.4573 88.1492 56.8776 87.8778C55.5627 87.2671 54.2849 86.6226 53.0503 85.955C51.1284 84.9143 49.3086 83.812 47.5859 82.6585C64.0706 71.626 71.5856 56.0078 71.5856 46.4398C71.5856 38.5514 67.8816 31.6411 62.3206 27.7846C65.2889 25.7318 68.7838 24.5444 72.525 24.5444C83.2827 24.5444 92.0001 34.3442 92.0001 46.4398Z",
    fill: "#A7163E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 59.9931H44.8298L47.6383 52.7241L51.8511 65.8552L57.5 39L65 76L69 59.9931H97",
    stroke: "#FFEADB",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.27543C0 5.93148 0.291786 5.64485 0.664196 5.6341C0.779375 5.63051 11.8634 5.25789 18.3595 0.163032C18.6282 -0.0519407 19.0237 -0.0555235 19.2924 0.15945L19.2963 0.163032C25.7923 5.26148 36.8495 5.6341 36.9608 5.63768C37.3294 5.64843 37.625 5.93148 37.625 6.27902V6.32918C37.625 15.1861 36.0739 27.5685 28.4261 36.2427C23.7959 41.4952 19.2079 42.8782 19.0121 42.9355L18.8048 43L18.5898 42.9355C18.394 42.8782 13.8329 41.4952 9.20277 36.2427C1.55107 27.5649 0 15.1861 0 6.32559V6.27543Z",
    fill: "#FF7D23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5735 21.0833L16.7399 25.0842C17.1272 25.4561 17.739 25.4557 18.1259 25.0834L27.1772 16.373C27.8312 15.7436 27.8312 14.6969 27.1772 14.0675C26.5578 13.4714 25.578 13.4714 24.9586 14.0675L17.43 21.3126L14.7896 18.776C14.1695 18.1803 13.1894 18.1814 12.5706 18.7786C11.9178 19.4086 11.9191 20.4549 12.5735 21.0833Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLifeInsurance);
export default __webpack_public_path__ + "static/media/imgLifeInsurance.8a4a47bb6df9a74586cb6128dcc05fc6.svg";
export { ForwardRef as ReactComponent };